export default __webpack_public_path__ + "static/media/upload.21591194.svg";